import classNames from "classnames";
import React, { useCallback, useEffect, useState } from "react";

export default function ({ className, showItems, children, marginTop }) {
  const [styles, setStyles] = useState({});
  const [ref, setRef] = useState(null);
  const setObjRef = useCallback(setRef, []);

  const childrens = React.Children.map(children, (child, id) => {
    if (id === 0) {
      return child;
    }
    return React.cloneElement(child, { style: { marginTop } });
  });

  const calcHeight = () => {
    const heightCurrent = ref.offsetHeight;
    const count = React.Children.count(children);
    const maxHeight = (heightCurrent / count) * showItems - 6;

    setStyles({ maxHeight });
  };

  useEffect(() => {
    if (ref) {
      setTimeout(calcHeight, 50);
    }
  }, [ref, showItems]);

  return (
    <div
      ref={setObjRef}
      className={classNames({ [className]: !!className })}
      style={styles}
    >
      {childrens}
    </div>
  );
}
